var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#ffffff",
    width: "800px",
    height: "800px",
    viewBox: "0 0 512 512",
    id: "_x30_1",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M256,0C114.615,0,0,114.615,0,256s114.615,256,256,256s256-114.615,256-256S397.385,0,256,0z M412,353.5 c0,20.193-16.37,36.562-36.562,36.562H136.562c-20.193,0-36.562-16.37-36.562-36.562v-195c0-20.193,16.37-36.562,36.562-36.562 h238.875c20.193,0,36.562,16.37,36.562,36.562V353.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M334.463,166.703L256,212.004l-78.463-45.301c-8.744-5.048-19.924-2.052-24.973,6.691 c-5.048,8.744-2.052,19.924,6.691,24.973l87.604,50.578l0.001-0.002c2.777,1.6,5.936,2.443,9.139,2.448 c3.204-0.004,6.363-0.848,9.139-2.448l0.001,0.002l87.604-50.578c8.744-5.048,11.74-16.229,6.691-24.973 C354.388,164.651,343.207,161.655,334.463,166.703z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.4b1cd1409f849de5c46f7aa9e906a7bf.svg";
export { ForwardRef as ReactComponent };